export default "__VITE_ASSET__CL1adW$e__"